async function ejecutarFuncionNetlify(nombre, body){
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    const resp = await fetch(`/.netlify/functions/${nombre}`, { method: "POST", headers, body: JSON.stringify(body) });
    return resp.status === 200 ? resp.json() : false;
}

export async function ejecutarFuncionMongo(nombreFuncion, parametros){
    //parametros viene con la forma de arguments { 0: param1, 1: param2, ...}
    const bodyAux = { funcion: nombreFuncion };
    if (parametros.hasOwnProperty('0')){
        bodyAux.parametros = parametros;
    }
    return ejecutarFuncionNetlify("user", bodyAux);
}

export async function encriptar(texto){
    return ejecutarFuncionNetlify("encrypt", { accion: 1, texto });
}
export async function desencriptar(texto){
    return ejecutarFuncionNetlify("encrypt", { accion: 0, texto });
}